module.exports = __webpack_public_path__ + "images/3-sim-phone-a.f4034a011dd0f4f5a015ab1de87c36eb.png";